import { render, staticRenderFns } from "./VideoTask.vue?vue&type=template&id=47296e17&scoped=true&"
import script from "./VideoTask.vue?vue&type=script&lang=js&"
export * from "./VideoTask.vue?vue&type=script&lang=js&"
import style0 from "./VideoTask.vue?vue&type=style&index=0&id=47296e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47296e17",
  null
  
)

export default component.exports